
import SegundaChamadaService from "@/service/v1/sigap/SegundaChamadaService"
import MatriculaService from "@/service/v1/sigap/MatriculaService"
import Multiselect from '@vueform/multiselect'
import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
import { Options, Vue } from "vue-class-component";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import SiteUtils from '@/assets/ts/aplicacao/site';
import $ from "jquery"
import { Prop } from 'vue-property-decorator';

@Options({
    name: "SegundaChamadaCadastro",
    components: { Multiselect, BotaoSalvar },
    emits: ['segunda-chamada-criada'],
})
export default class SegundaChamadaCadastro extends Vue {
    @Prop() readonly modal!: any
    @Prop() readonly perfis!: any
    @Prop() readonly disciplina!: any

    public service = new SegundaChamadaService();
    public matriculaService = new MatriculaService();

    public processando = false;
    public titulo = 'Cadastrar Segunda Chamada';

    public matriculaId: any = null;
    public dataAvaliacao: any = null;
    public dataSolicitacao: any = null;
    public justificativa: any = null;
    public parecer: any = null;
    public statusId: any = null;
    public status: any = null;

    created() {
        this.getStatus();
    }

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => { return { value: item.id, label: item.nome } });
        }
        return null;
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(error => {
                this.processando = false;
            });
    }

    public async buscarAluno(query) {
        if (query) {
            const response = await this.matriculaService.getAllWithUsuario("turmaId=" + this.disciplina?.turmaId + "&Take=200&search=" + query);
            return response.data.map((item) => {
                return { value: item.id, label: item.numeroCurso + (item.isRemanescente ? '(R)' : '') + ' - ' + item.usuario.nome + ' - RG ' + item.usuario.rg + ' ( ' + item.pelotao + 'º pelotão)' }
            })
        }
        return [];
    }

    public getdados() {
        let dados: any = {};
        dados.matriculaId = this.matriculaId;
        dados.disciplinaId = this.disciplina.id;
        dados.dataAvaliacao = this.dataAvaliacao;
        dados.dataSolicitacao = this.dataSolicitacao;
        dados.justificativa = this.justificativa;
        dados.parecer = this.parecer;
        dados.status = this.statusId;
        return dados;
    }

    public sucesso() {
        this.$emit("segunda-chamada-criada", null);
        this.matriculaId = null;
        this.dataAvaliacao = null;
        this.dataSolicitacao = null;
        this.justificativa = null;
        this.parecer = null;
        this.statusId = null;
        $("[data-bs-dismiss='modal']").trigger({ type: "click" });
    }

    public salvar() {
        if (this.processando || !this.hasPermissao) {
            return;
        }
        if (!this.matriculaId || !this.dataAvaliacao || !this.dataSolicitacao || !this.justificativa || !this.statusId) {
            SiteUtils.toastErro('Error!', 'Preencha os campos obrigatorios.');
            return;
        }
        this.processando = true;
        const dados = this.getdados();
        setTimeout(() => {
            this.service.cadastrar(dados)
                .then(response => {
                    SiteUtils.toastSucesso('Cadastrado com sucesso!', response.message);
                    this.sucesso();
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro('Error!', error.data.message);
                });
        }, 100);
    }
}
